interface ProgramRefProps {
  cite: string
  loc: string
  verified?: boolean
}

export default function ProgramRef({ cite, loc, verified = true }: ProgramRefProps) {
  return (
    <sup className={`program-ref ${verified ? '' : 'program-ref--unverified'}`}>
      <a href={`/sources/${cite}#${loc.replace(/\s/g, '-').toLowerCase()}`}>
        {cite.toUpperCase()} {loc}
        {!verified && ' [unverified]'}
      </a>
    </sup>
  )
}
